import { Analytics } from '@cobliteam/analytics';
import AlertIcon from '@cobliteam/business-manager/src/components/AlertIcon';
import Button from '@cobliteam/colib-ui/Button';
import { Location } from '@cobliteam/common-types';
import { useMultipleContractMenu } from '@cobliteam/hooks/src/useEntity/useBusinessManager';
import { useOverdueBillets } from '@cobliteam/hooks/src/useEntity/useErp/useBillets';
import Icon from '@cobliteam/ui/icons';
import TooltipOnIntent from '@cobliteam/ui-business/components/TooltipOnIntent/TooltipOnIntent';
import { useHistory } from 'react-router-dom';

const BoletosButton = () => {
  const history = useHistory();
  const { data: multipleContracts } = useMultipleContractMenu();
  const { data: overdueBoletos } = useOverdueBillets(multipleContracts);

  const hasOverdueBoletos = overdueBoletos && overdueBoletos?.length > 0;

  const handleClick = () => {
    Analytics.track('NavBar - Boletos - Click');
    history.push(Location.BUSINESS_MANAGER_BOLETOS);
  };

  if (!hasOverdueBoletos) return null;

  return (
    <TooltipOnIntent
      render={
        <div className='relative pt-4'>
          <Button aria-label='Existe um ou mais boletos atrasados' variant='secondary' size='icon-sm' data-testid='app-header-boletos-button' onClick={handleClick}>
            <Icon name='dollar-sign' />
          </Button>
          {hasOverdueBoletos && (
            <div className='absolute top-2 -right-1 flex items-center justify-center'>
              <AlertIcon size='xs' />
            </div>
          )}
        </div>
      }
      contentProps={{ className: 'w-32', side: 'left' }}
    >
      Existe um ou mais boletos atrasados
    </TooltipOnIntent>
  );
};

export default BoletosButton;
